import { render, staticRenderFns } from "./house.vue?vue&type=template&id=5d1d3fd3"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1d3fd3')) {
      api.createRecord('5d1d3fd3', component.options)
    } else {
      api.reload('5d1d3fd3', component.options)
    }
    module.hot.accept("./house.vue?vue&type=template&id=5d1d3fd3", function () {
      api.rerender('5d1d3fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quarter/house.vue"
export default component.exports